export enum Socials {
    DISCORD = 'DISCORD',
    TWITTER = 'TWITTER',
    TELEGRAM = 'TELEGRAM',
    MEDIUM = 'MEDIUM',
    GITBOOK = 'GITBOOK',
    LINKEDIN = 'LINKEDIN',
}
